import type { ImagePurpose } from '@/api/models';
import type { ImageUploadPayload } from '@/components/imageCropUpload';
import { base64ToBlob } from '@/utils/base64ToBlob';
import { getAxiosClient } from '../../client';
import { makeApiRequest } from '../../makeApiRequest';
import type { ApiResponse } from '../../responses';
import type { IImagesService } from './IImagesService';
import { ImagesEndpoints } from './imagesEndpoints';
import type { UploadImageResponse } from './responses';

type ImagesServiceOptions = {
    baseUrl: string;
};

export class ImagesService implements IImagesService {
    private readonly baseUrl: string;

    constructor({ baseUrl }: ImagesServiceOptions) {
        this.baseUrl = baseUrl;
    }

    public uploadImage(
        payload: ImageUploadPayload,
        purpose: ImagePurpose,
    ): Promise<ApiResponse<UploadImageResponse>> {
        const url = ImagesEndpoints.upload();

        // The bos-api binds `file` as IFormFile via multipart/form-data. We
        // hold the cropped image as base64 in memory; convert to a Blob so
        // axios sends raw bytes (smaller payload, lets the server's
        // magic-byte sniff work without base64-decoding).
        const formData = new FormData();
        formData.append(
            'file',
            base64ToBlob(payload.dataBase64, payload.mimeType),
            payload.fileName,
        );
        formData.append('purpose', purpose);

        // Let the browser pick the multipart boundary by leaving Content-Type
        // unset; axios will populate it from the FormData instance.
        return makeApiRequest<UploadImageResponse>(
            getAxiosClient({ baseURL: this.baseUrl }).post(url, formData),
        );
    }
}
